module.exports = __webpack_public_path__ + "static/design-09095d02e6b6a4c172ebf92595d73c5d.png";